import { openBlock as l, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return l(), t("svg", o, [...e[0] || (e[0] = [
    c("g", { "clip-path": "url(#a)" }, [
      c("path", {
        fill: "currentColor",
        d: "M12 9.273c1.5 0 2.727 1.227 2.727 2.727S13.5 14.727 12 14.727A2.735 2.735 0 0 1 9.273 12c0-1.5 1.227-2.727 2.727-2.727m0-1.818A4.547 4.547 0 0 0 7.455 12 4.547 4.547 0 0 0 12 16.546 4.547 4.547 0 0 0 16.546 12 4.547 4.547 0 0 0 12 7.455m-9.09 5.454h1.817c.5 0 .91-.409.91-.909s-.41-.91-.91-.91H2.91c-.5 0-.909.41-.909.91s.41.91.91.91m16.363 0h1.818c.5 0 .909-.409.909-.909s-.41-.91-.91-.91h-1.817c-.5 0-.91.41-.91.91s.41.91.91.91m-8.182-10v1.818c0 .5.409.91.909.91s.91-.41.91-.91V2.91c0-.5-.41-.909-.91-.909s-.91.41-.91.91m0 16.364v1.818c0 .5.409.909.909.909s.91-.41.91-.91v-1.817c0-.5-.41-.91-.91-.91s-.91.41-.91.91M6.536 5.255a.905.905 0 1 0-1.282 1.282l.964.963a.905.905 0 0 0 1.282 0c.345-.355.355-.936 0-1.282zM17.782 16.5a.905.905 0 1 0-1.282 1.282l.964.963a.905.905 0 1 0 1.282-1.282zm.963-9.964a.905.905 0 1 0-1.282-1.282l-.963.964a.905.905 0 0 0 0 1.282c.355.345.936.355 1.282 0zM7.5 17.782A.905.905 0 1 0 6.218 16.5l-.963.964a.905.905 0 0 0 0 1.282c.354.345.936.354 1.281 0z"
      })
    ], -1),
    c("defs", null, [
      c("clipPath", { id: "a" }, [
        c("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
